import { FormikProps } from "formik";
import React, { useState, useEffect } from "react";
import SuggestionSelectField from "src/components/common/formFields/suggestionSelectField/suggestionSelectField";
import { componentSizeVariantsEnum } from "src/constants";
import axios from "axios";
import debounce from "lodash/debounce";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { getCoFounder } from "src/store/venture/venture.slice";
import { useGetIdentity } from "src/hooks";
import Label from "src/components/common/formFields/label/Label";
import cx from './cofonderdropdown.module.scss'
import { MdAdd } from "react-icons/md";
import { TCofounderDropDownOption, TCofounderRequest } from "src/services/apiEndpoint.types.ts/ventures/ventures.types";

export default function CoFounderDropDown({
    values,
    setFieldValue,
    touched,
    errors,
    index,
    value,
    handleAction
}: FormikProps<any> & { index: number, value?: { userType?: string, id?: string }, handleAction?: () => void }) {
    const dispatch = useAppDispatch();
    const { singleVenture } = useAppSelector(
        (store) => store.venture
    );
    const { getIdentities }: any = useGetIdentity();
    const { authenticatedId, loggedInUserType } = getIdentities();
    const [options, setOptions] = useState<TCofounderDropDownOption[]>([]);

    // Debounced API call
    const fetchSuggestions = debounce(async (query: string) => {
        if (!query?.trim()) return;
        const payload: TCofounderRequest = {
            page: 1,
            limit: 20,
            name: query,
            userId: authenticatedId
        }
        dispatch(getCoFounder(payload)).then((response: any) => {
            if (response.status) {
                const users: TCofounderDropDownOption[] = response.data.data.users.map((item: any) => ({
                    label: item.name,
                    value: item.id,
                    type: "User",
                    logo: item?.profilePic || 'init'
                }))

                const allUsers: TCofounderDropDownOption[] = [...users]
                setOptions(
                    allUsers
                );
            }
        })
    }, 300);
    useEffect(() => {
        if (singleVenture) {
            const selectedCoFounder = singleVenture?.CoFounders?.find((item: { userId: string, Company: { id: string } }) => item.userId === value?.id || item?.Company?.id === value?.id);
            if (selectedCoFounder) {
                fetchSuggestions(selectedCoFounder?.User?.name || selectedCoFounder?.Company?.name)
            }
        }
    }, [singleVenture])

    return (
        <>
            <div className={cx.topHeading}>
                <Label>Co-Founders</Label>
                <span className={cx.actionButton} onClick={handleAction}>
                    {index === 0 ? (
                        <>
                            <MdAdd className={cx.icon} /> Add
                        </>
                    ) : (
                        <>
                            Remove
                        </>
                    )}
                </span>
            </div>
            <SuggestionSelectField
                options={options}
                value={options.find((item) => item.value === value?.id)?.label || ''}
                placeholder="Search and Select Co-founder"
                onChange={(selectedOption, actionMeata, e) => {
                    fetchSuggestions(selectedOption?.label)
                    const newCoFounders = values?.coFounders ? [...values?.coFounders] : [];
                    const data: any = options.find((item) => item.value === selectedOption?.value) || '';
                    if (data?.type) {
                        newCoFounders[index] = { userType: data?.type, id: data?.value };
                    } else {
                        newCoFounders[index] = ''
                    }

                    setFieldValue("coFounders", newCoFounders);
                }}
                variant={componentSizeVariantsEnum.SMALL}
            />
        </>
    );
}
